import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Button, Container, Input, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import PDFTab from './Demo1';

const Demo1 = () => {


    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <Col>
                        <BreadCrumb title="Document Scanner"  pageTitle="Dashboard"/>
                        <Card>
                            <CardBody>
                                <Row>
                                    <PDFTab />
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Demo1;
